// Admin "Lab Orders" dashboard — cross-lab order browsing. Thin wrapper
// around the shared LabOrdersView (see that file for the full design/
// architecture rationale); this just selects admin auth/endpoints.
import React from "react";
import LabOrdersView from "./LabOrdersView";

export default function LabOrdersDashboard() {
  return <LabOrdersView isAdmin />;
}
